import { useProductImages } from '../hooks/useProductImages';
import CaretRight from '@vtex/styleguide/lib/icon/CaretRight';

const SwiperCaretNext = () => {
	const { blockClass } = useProductImages();

	const renderClass = () => {
		return (
			blockClass &&
			`vtex-store-components-3-x-swiperCaret--${blockClass} vtex-store-components-3-x-swiperCaretNext--${blockClass}`
		);
	};

	return (
		<span
			className={`swiperCaret swiperCaretNext swiperCaret--${blockClass} swiperCaretNext--${blockClass} swiper-caret-next pl7 pr2 right-0 pv8 absolute top-50 translate--50y z-2 pointer c-action-primary vtex-store-components-3-x-swiperCaret vtex-store-components-3-x-swiperCaretNext ${renderClass()}`}
		>
			<CaretRight orientation="right" size={24} />
		</span>
	);
};

export default SwiperCaretNext;
